export default {
  label: {
    margin: 0,
    color: (theme) => theme.palette.grays.gray700,
    fontSize: '1rem',
    fontWeight: 500,
    lineHeight: '23px',
    marginTop: 0,
    display: 'flex',
    alignItems: 'center',
    gap: '2px',
  },

  asterik: {
    color: (theme) => theme.palette.blues.primaryBlue500,
  },
};
